import type { FC } from "react";
import { DragDropContainer } from "../../DragDropContainer";
import type { ComponentOptions, InternalColumnType } from "../../DragDropTypes";

interface Props extends ComponentOptions<[ InternalColumnType, InternalColumnType ]> {}

export const ColumnComponentEdit: FC<Props> = ({ value }) => {
    // The one pixel height is to fix "h-full" not working on the "td" tags
    return (
        <table className="h-[1px] table-fixed">
            <tbody>
                <tr>
                    {value.map(column => (
                        <td
                            key={column.id}
                            className="border-none padding-1 align-top h-full"
                            style={{
                                width: `${Math.round(column.width * 100)}%`,
                            }}
                        >
                            <DragDropContainer
                                id={column.id}
                            />
                        </td>
                    ))}
                </tr>
            </tbody>
        </table>
    );
};
